/* global axios */
import ApiClient from './ApiClient';

class AttachmentAPI extends ApiClient {
  constructor() {
    super('attachments', { accountScoped: true });
  }

  refreshUrl(attachmentId) {
    return axios.get(`${this.url}/${attachmentId}/refresh_url`);
  }
}

export default new AttachmentAPI();
